<router-outlet></router-outlet>

<p-toast />
